import apiClient from './apiClient';
import {
  PersonUnlockRequest,
  PersonUnlockResponse,
  BulkUnlockRequest,
  BulkUnlockResponse,
  UnlockEstimateRequest,
  UnlockEstimateResponse,
  JobStatusResponse,
  BatchStatusResponse,
  ActiveBatchResponse,
} from '../types/results.types';

export type { UnlockEstimateRequest };

export const dmUnlockApi = {
  /**
   * Enrich a single person (discover email)
   */
  unlockPerson: async (
    personId: number,
    request?: PersonUnlockRequest
  ): Promise<PersonUnlockResponse> => {
    const response = await apiClient.post<PersonUnlockResponse>(
      `/v1/dm-unlock/person/${personId}`,
      request || {}
    );
    return response.data;
  },

  /**
   * Enrich all people at a company
   */
  unlockPlace: async (
    placeId: number,
    searchId?: number
  ): Promise<BulkUnlockResponse> => {
    const params = searchId ? { search_id: searchId } : {};
    const response = await apiClient.post<BulkUnlockResponse>(
      `/v1/dm-unlock/place/${placeId}`,
      null,
      { params }
    );
    return response.data;
  },

  /**
   * Bulk enrich selected people from a search
   */
  unlockBulk: async (
    searchId: number,
    request: BulkUnlockRequest
  ): Promise<BulkUnlockResponse> => {
    const response = await apiClient.post<BulkUnlockResponse>(
      `/v1/dm-unlock/search/${searchId}/bulk`,
      request
    );
    return response.data;
  },

  /**
   * Get cost breakdown without charging
   */
  estimateCost: async (
    request: UnlockEstimateRequest
  ): Promise<UnlockEstimateResponse> => {
    const response = await apiClient.post<UnlockEstimateResponse>(
      '/v1/dm-unlock/estimate',
      request
    );
    return response.data;
  },

  /**
   * Get job status by token (legacy)
   */
  getJobStatus: async (jobToken: string): Promise<JobStatusResponse> => {
    const response = await apiClient.get<JobStatusResponse>(
      `/v1/dm-unlock/job/${jobToken}`
    );
    return response.data;
  },

  /**
   * Get batch status by batch ID
   */
  getBatchStatus: async (batchId: string): Promise<BatchStatusResponse> => {
    const response = await apiClient.get<BatchStatusResponse>(
      `/v1/dm-unlock/batch/${batchId}/status`
    );
    return response.data;
  },

  /**
   * Get active (in-progress) batch for current user
   * Used to restore UI state after page refresh
   */
  getActiveBatch: async (searchId?: number): Promise<ActiveBatchResponse> => {
    const params = searchId ? { search_id: searchId } : {};
    const response = await apiClient.get<ActiveBatchResponse>(
      '/v1/dm-unlock/active',
      { params }
    );
    return response.data;
  },
};
